import { apiUrl } from './../constants/apiUrl'
import api from '../service/apiService'
import { Utils } from '../util/utils';
import { errorAction } from './errorAction'
import { logKafka, logOtherInfo, detailsInfo, catchJSException } from './../service/logService';
import { getVZDLInit } from '../service/vzdl'

let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;

export const getCategoriesFromAPI = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('AccessoriesHome', visitId, 'getCategoriesFromAPI', "Inside getCategoriesFromAPI"));
        var response;
        var categoriesData=window.catresp
        const categoriesUrl = apiUrl().categoriesUrl;
        // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        if (categoriesData !== undefined && categoriesData !== "" && categoriesData !== null  )
        {
            var response=categoriesData
            response = response.map(object => { return { ...object, actualImagePath: Utils.getDomainUrl().concat(object.imagePath), modifiedName: Utils.removeSpecialChars(object.name) } }
            )
            dispatch({ type: 'CATEGORIESFROMAPI', value: response });
               window.catresp=""
        }
        else{
        api(categoriesUrl, 'GET', '').then(response => {
            if (Utils.isNotNull(response)) {
                response = response.map(object => { return { ...object, actualImagePath: Utils.getDomainUrl().concat(object.imagePath), modifiedName: Utils.removeSpecialChars(object.name) } }
                )
                dispatch({ type: 'CATEGORIESFROMAPI', value: response });
                // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
            else {
                // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                errorAction("LBO", "Category", "Category", "applogs", visitId, dispatch, true, "CategoryFailed")
            }
        }).catch(error => {
            let errorMsg = `MethodName:getCategoriesFromAPI,errorMessage:${error.message}`;
            logKafka("ERROR", "AccessoriesHome", errorMsg, getErrorLogUrl, "applogs", visitId);
            getVZDLInit(visitId,"","","","","","",error.message);
            // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
        return response;
    }
    } catch (ex) {
        catchJSException('AccessoriesHome', visitId, 'getCategoriesFromAPI', ex);
    }
}

export const getStandardErrorsFromAPI = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('AccessoriesHome', visitId, 'getStandardErrorsFromAPI', "Inside getStandardErrorsFromAPI"));
        var response;
        var stdErrData=window.strerrresp
        const standardErrorsUrl = apiUrl().standardErrors;
        // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        if (stdErrData !== undefined && stdErrData !== "" && stdErrData !== null  )
        {
            dispatch({ type: 'STANDARDERRORSFROMAPI', value: stdErrData });  
            window.strerrresp=""
        }
        else{
        api(standardErrorsUrl, 'GET', '').then(response => {
            if (Utils.isNotNull(response)) {               
                dispatch({ type: 'STANDARDERRORSFROMAPI', value: response });                
                // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
            else {
                // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                errorAction("LBO", "Category", "Category", "applogs", visitId, dispatch, true, "StandardErrorsFailed")
            }
        }).catch(error => {
            let errorMsg = `MethodName:getStandardErrorsFromAPI,errorMessage:${error.message}`;
            logKafka("ERROR", "AccessoriesHome", errorMsg, getErrorLogUrl, "applogs", visitId);
            getVZDLInit(visitId,"","","","","","",error.message);
            // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
        return response;
    }
    } catch (ex) {
        catchJSException('AccessoriesHome', visitId, 'getStandardErrorsFromAPI', ex);
    }
}

export const getbannerFromAPI = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('AccessoriesHome', visitId, 'getbannerFromAPI', "Inside getbannerFromAPI"));
        var response;
        var bannerData=window.bannerresp
        const bannerUrl = apiUrl().bannerUrl;
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        if (bannerData !== undefined && bannerData !== "" && bannerData !== null  )
            {
                var response=bannerData
                dispatch({ type: 'BANNERFROMAPI', value: response });
                // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } })
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: "RESET_LOADER"}}); 
                window.bannerresp=""
            }
        else{    
        api(bannerUrl, 'GET', '').then(response => {
            if (Utils.isNotNull(response)) {
                
                dispatch({ type: 'BANNERFROMAPI', value: response });
                // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } })
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: "RESET_LOADER"}}); 
            }
        }).catch(error => {
            // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } })
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: "RESET_LOADER"}}); 
            let errorMsg = `MethodName:getbannerFromAPI,errorMessage:${error.message}`;
            logKafka("ERROR", "AccessoriesHome", errorMsg, getErrorLogUrl, "applogs", visitId);
            getVZDLInit(visitId,"","","","","","",error.message);
        })
        return response;
    }
    } catch (ex) {
        catchJSException('AccessoriesHome', visitId, 'getbannerFromAPI', ex);
    }

}
export const getShoppingCartContent = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('AccessoriesHome', visitId, 'getShoppingCartContent', "Inside getShoppingCartContent"));
        var response;
        const shoppingCartContentUrl = apiUrl().shoppingCartContentUrl;
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        api(shoppingCartContentUrl, 'GET', '').then(response => {
            if (Utils.isNotNull(response)) {
                dispatch({ type: 'SHOPPINGCARTCONTENTFROMAPI', value: response });
                 dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
            else {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
        }).catch(error => {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            let errorMsg = `MethodName:getShoppingCartContents,errorMessage:${error.message}`;
            logKafka("ERROR", "AccessoriesHome", errorMsg, getErrorLogUrl, "applogs", visitId);
            getVZDLInit(visitId,"","","","","","",error.message);
        })
        return response;
    } catch (ex) {
        catchJSException('AccessoriesHome', visitId, 'getShoppingCartContent', ex);
    }

}


export const getHeaderContent = (dispatch, visitId) => {
    try {
        logOtherInfo(detailsInfo('AccessoriesHome', visitId, 'getHeaderContent', "Inside getHeaderContent"));
        var response;
        var headerData=window.tbarresp
        const headerContentUrl = apiUrl().headerContentUrl;
        if (headerData !== undefined && headerData !== null && headerData !== "" && headerData.description !== null && headerData.description !== "null"  )
        {
            dispatch({ type: 'HEADERCONTENTFROMAPI', value: headerData });
        }
        else{
        api(headerContentUrl, 'GET', '').then(response => {
            if (Utils.isNotNull(response)) {
                dispatch({ type: 'HEADERCONTENTFROMAPI', value: response });
            }
        }).catch(error => {
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            let errorMsg = `MethodName:getHeaderContent,errorMessage:${error.message}`;
            logKafka("ERROR", "AccessoriesHome", errorMsg, getErrorLogUrl, "applogs", visitId);
            getVZDLInit(visitId,"","","","","","",error.message);
        })
        return response;
    }
    } catch (ex) {
        catchJSException('AccessoriesHome', visitId, 'getHeaderContent', ex);
    }

}

export const updateFlowType =(flowType,dispatch) => {
    if (flowType ) {
        const updateFlowTypeUrl = apiUrl().updateFlowType;
        let request = JSON.stringify({ flowType,"vtp":"Y" });
        api(updateFlowTypeUrl, 'POST', request).then(response => {
         dispatch({ type: 'UPDATEFLOWTYPE', value: flowType })   
        })
       .catch(error => {
        
       });
    }
}

export const updateFlowSubType =(flow_subtype,dispatch, visitId) => {
    try{
    logOtherInfo(detailsInfo('AccessoriesHome', visitId, 'updateFlowSubType', "Inside updateFlowSubType"));
    if (flow_subtype) {
        const updateVisitDetailsUrl = apiUrl().updateVisitDetails;
        let request = JSON.stringify({ flow_subtype ,"vtp":"Y"});
        api(updateVisitDetailsUrl, 'POST', request).then(response => {
            if(response && response.data)
                dispatch({ type: 'UPDATEFLOWSUBTYPE', value: flow_subtype })   
        })
       .catch(error => {
        let errorMsg = `MethodName:updateFlowSubType,errorMessage:${error.message}`;
        logKafka("ERROR", "AccessoriesHome", errorMsg, getErrorLogUrl, "applogs", visitId);
       });
    }
} catch(ex) {
    catchJSException('AccessoriesHome', visitId, 'updateFlowSubType', ex);
}
}

export const updateClientIp =(dispatch,clientIp) => {
    dispatch({ type: 'UPDATE_CLIENTIP', value: clientIp });    
}
export const updateMvaType =(dispatch, mvaType) => {
    dispatch({ type: 'UPDATE_MVATYPE', value: mvaType });    
} 
export const isMvaFlow =(dispatch, isMvaFlow) => {
    dispatch({ type: 'MVAFLOW', value: isMvaFlow });    
}
export const updateAcceptHeader =(dispatch,acceptHeader) => {
    dispatch({ type: 'UPDATE_ACCEPT_HEADER', value: acceptHeader });    
}
export const updateMlpFlow =(dispatch,isMLP) => {
    dispatch({ type: 'UPDATE_MLPFLOW', value: isMLP });    
}
export const updateMlpPDP =(dispatch,pdpName) => {
    dispatch({ type: 'UPDATE_MLPPDP', value: pdpName });    
}
export const getfeaturedAccessoriesFromAPI = (dispatch, visitId, request) => {
    try {
        logOtherInfo(detailsInfo('AccessoriesHome', visitId, 'getfeaturedAccessoriesFromAPI', "Inside getfeaturedAccessoriesFromAPI"));
        var response;
        var selectedResponse;
        var ftAccData=window.ftresp
        const featuredAccessoriesUrl = apiUrl().featuredAccessoriesUrl;
        // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
        // if (ftAccData !== undefined && ftAccData !== "" && ftAccData !== null  )
        // {
        //    var response=ftAccData
        //    selectedResponse = response.map((object, index) => {
        //     return { ...object, selectedProd: object.items[0], groupId: "G" + index, modifiedName: Utils.removeSpecialChars(object.name) }
        // })
        //     dispatch({ type: 'FEATUREDACCESSORIESFROMAPI', value: selectedResponse });
        //     window.ftresp=""
           
        // }
        // else{
        api(featuredAccessoriesUrl, 'POST', request).then(response => {
            if (Utils.isNotNull(response)) {
                selectedResponse = response.products.map((object, index) => {
                    return { ...object, selectedProd: object.items[0], groupId: "G" + index, modifiedName: Utils.removeSpecialChars(object.name) }
                })

                dispatch({ type: 'FEATUREDACCESSORIESFROMAPI', value: selectedResponse });
                // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
            // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        }).catch(error => {
            // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            let errorMsg = `MethodName:getfeaturedAccessoriesFromAPI,errorMessage:${error.message}`;
            logKafka("ERROR", "AccessoriesHome", errorMsg, getErrorLogUrl, "applogs", visitId);
            getVZDLInit(visitId,"","","","","","",error.message);

        })
        return response;
    // }
    } catch (ex) {
        catchJSException('AccessoriesHome', visitId, 'getfeaturedAccessoriesFromAPI', ex);
    }
}

export const getDigitalVisaCardInfo = (visitId, dispatch) => {
    try {
      console.log("getDigitalVisaCardInfo  in productAction")
      logOtherInfo(detailsInfo('ShoppingCartPage', visitId, 'getDigitalVisaCardInfo', 'Inside shoppingCart'));
      const getDigitalVisaCardInfoUrl = apiUrl().checkUserCreditCardInfo;
      return new Promise((resolve, reject) => {
        api(getDigitalVisaCardInfoUrl, 'GET', '')
          .then((res) => {
            console.log(res,typeof(res), "getdigitalvisacardinfo");
            if (res && typeof res === "object" && Object.keys(res).length > 0) {
              dispatch({ type: 'DIGITALVISACARDINFOCALL', value: res });
              dispatch({ type: 'CUSTOMERWALLETAMOUNT', value: res?.transactions[0]?.data?.wirelineCustomerWalletAmount ? res?.transactions[0]?.data?.wirelineCustomerWalletAmount.toString() : 0 });
              dispatch({ type: 'GETVISACARDCALL', value: true });
              if (res?.transactions[0]?.data?.wirelineCustomerCCIndicator !== 'Y' && res?.transactions[0]?.data?.wirelessCustomerCCIndicator !== 'Y' && Number(res?.transactions[0]?.data?.wirelineCustomerWalletAmount) <= 0 ) {
                dispatch({ type: 'NONVVCACCOUNT', value: true });
              }
              resolve(res);
            }
          })
          .catch((error) => {
            let errorMsg = `MethodName:checkUserCreditCardInfo,errorMessage:${error.message}`;
            logKafka('ERROR', 'ShoppingCartPage', errorMsg, getErrorLogUrl, 'applogs', visitId);
            getVZDLInit(visitId, '', '', '', '', '', '', error.message);
          });
      });
    } catch (ex) {
      catchJSException('ShoppingCartPage', visitId, 'getDigitalVisaCardInfo', ex);
    }
  };
  

export const setCookie = (cookies, data, props) => {
    {
        let domain = "localhost";
        if (document.location.href.indexOf("localhost") > -1) {
            //cookies.set('visit_id', data.visit_id, { path: '/', 'domain': domain });
            cookies.set('visit_id_vtp', data.visit_id, { path: '/', 'domain': domain });
            cookies.set('visitor_id', data.visitor_id, { path: '/', 'domain': domain });
        }
        props.dispatch({ type: "UPDATE_VISITID", value: { visitId: data.visit_id, visitorId: data.visitor_id } });
    }
}

export const storeCategoryId = (dispatch, request) => {
    dispatch({ type: 'STORECATEGORYID', value: request });
}
export const featuredAccessoriesvalue = (request, dispatch) => {
    dispatch({ type: 'FEATUREDACCESSORIESFROMAPI', value: request });
}

export const updateValidUser = (request, dispatch) => {
    dispatch({ type: 'VALIDUSER', value: request });
}

export const updateProfileCall = (request, dispatch) => {
    dispatch({ type: 'PROFILECALL', value: request });
}

export const updateGuestFlow = (request, dispatch) => {
    dispatch({ type: 'ISGUESTFLOW', value: request });
}

export const updateSigninApplied = (request, dispatch) => {
    dispatch({ type: 'ISSIGNINAPPLIED', value: request });
}
export const isMVAFiosEqipFlow =(dispatch, isFiosEqpVal) => {
    dispatch({ type: 'MVAFIOSEQP', value: isFiosEqpVal });    
}
export const mvaRequestUrl =(dispatch, requestUrl) => {
    dispatch({ type: 'MVAREQUESTURL', value: requestUrl });    
}


